// extracted by mini-css-extract-plugin
module.exports = {"day":"_3wVrH153r2F4","day_fromOtherMonth":"_1GZq-HX16RWg","day_selected":"_186DJ8-DcqWF"};